import styled from 'styled-components';

export const PaginationButtons = styled.div``;

export const LoadingWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 200px;
`;
